module.exports = "/_next/static/images/Ion_Untila-e99e127d3a09fa22693fb92a5205cf03.webp";